<template>
    <div>
        <div id="content">
            <div class="c-title"><span>心率趋势图</span></div>
            <div class="main" id="heartRate"></div>
            <div class="count">
                <div v-for="(item, index) in HrInfo" :key="index">
                    <p class="val">{{item.num}}</p>
                    <p class="title">{{item.name}}/bmp</p>
                </div>
            </div>
            <div class="c-title"><span>血压趋势图</span></div>
            <div class="main" id="bloodPressure"></div>
            <div class="c-title"><label>高压（收缩压）</label></div>
            <div class="count">
                <div v-for="(vo, index) in BpInfo" :key="index">
                    <p class="val">{{vo.num}}</p>
                    <p class="title">{{vo.name}}/mmHg</p>
                </div>
            </div>
            <div class="c-title"><label>低压（舒张压）</label></div>
            <div class="count">
                <div v-for="(vo, index) in BpInfoA" :key="index">
                    <p class="val">{{vo.num}}</p>
                    <p class="title">{{vo.name}}/mmHg</p>
                </div>
            </div>
            <div class="c-title"><span>血氧趋势图</span></div>
            <div class="main" id="bloodOxygen"></div>
            <div class="count">
                <div v-for="(vo, index) in BoInfo" :key="index">
                    <p class="val">{{vo.num}}</p>
                    <p class="title">{{vo.name}}</p>
                </div>
            </div>
            <div v-if="BsInfo">
                <div class="c-title"><span>血糖记录</span></div>
                <div class="c-bs">
                    <van-row class="s1">
                        <van-col span="6" class="c-1">时间</van-col>
                        <van-col span="3" class="c-1">凌晨</van-col>
                        <van-col span="4">
                            <van-col span="24">早餐</van-col>
                            <van-col span="12">前</van-col>
                            <van-col span="12">后</van-col>
                        </van-col>
                        <van-col span="4">
                            <van-col span="24">午餐</van-col>
                            <van-col span="12">前</van-col>
                            <van-col span="12">后</van-col>
                        </van-col>
                        <van-col span="4">
                            <van-col span="24">晚餐</van-col>
                            <van-col span="12">前</van-col>
                            <van-col span="12">后</van-col>
                        </van-col>
                        <van-col span="3" class="c-1">睡前</van-col>
                    </van-row>
                    <van-row v-for="(vo, index) in BsInfo" :key="index" class="s2">
                        <van-col span="6">{{vo.time}}</van-col>
                        <van-col span="3" v-bind:class="vo.type === 0 ? vo.bg_color : ''">{{vo.type === 0 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 1 ? vo.bg_color : ''">{{vo.type === 1 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 2 ? vo.bg_color : ''">{{vo.type === 2 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 3 ? vo.bg_color : ''">{{vo.type === 3 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 4 ? vo.bg_color : ''">{{vo.type === 4 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 5 ? vo.bg_color : ''">{{vo.type === 5 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="2" v-bind:class="vo.type === 6 ? vo.bg_color : ''">{{vo.type === 6 ? vo.bloodSugar : ''}}</van-col>
                        <van-col span="3" v-bind:class="vo.type === 7 ? vo.bg_color : ''">{{vo.type === 7 ? vo.bloodSugar : ''}}</van-col>
                    </van-row>
                </div>
            </div>
            <div class="c-title"><span>步数柱状图</span></div>
            <div class="main" id="motion"></div>
            <div class="count">
                <div v-for="(vo, index) in mInfo" :key="index">
                    <p class="val">{{vo.num}}</p>
                    <p class="title">{{vo.name}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {List, Col, Row} from 'vant';

    Vue.use(List)
        .use(Col)
        .use(Row);

    import { dailyPaper } from '../../api/health';

    let echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/line');
    require('echarts/lib/chart/bar');

    // 引入提示框和title组件
    require('echarts/lib/component/title');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');

    export default {
        name: "dailyPaper",
        data() {
            return {
                name: '',
                create_time: '',
                headimg: '',

                HrInfo: [
                    {num: '0', name: '最高'},
                    {num: '0', name: '平均'},
                    {num: '0', name: '最低'}
                ],
                BpInfo: [
                    {num: '', name: '最高'},
                    {num: '', name: '平均'},
                    {num: '', name: '最低'}
                ],
                BpInfoA: [
                    {num: '', name: '最高'},
                    {num: '', name: '平均'},
                    {num: '', name: '最低'}
                ],
                BoInfo: [
                    {num: '0', name: '最高(%)'},
                    {num: '0', name: '平均(%)'},
                    {num: '0', name: '最低(%)'}
                ],
                mInfo: [
                    {num: '', name: '步数/步'},
                    {num: '', name: '历程/公里'},
                    {num: '', name: '卡路里/卡'}
                ],
                BsInfo: []
            }
        },
        mounted() {
            let _this = this;
            document.title = '日报-健康管理';

            dailyPaper({token: this.$route.query.token})
                .then(res => {
                    if (res.code === 1) {
                        let data = res.content;
                        _this.name = data.info.name;
                        _this.headimg = data.info.headimg;
                        _this.create_time = data.info.create_time;
                        document.title = data.info.createTime + ' 健康日报';

                        // 血糖
                        _this.BsInfo = data.bsDailyPaper;

                        var X = []
                            , Y = []
                            , HrData = data.hrDailyPaper
                            , BpData = data.bpDailyPaper
                            , BoData = data.boDailyPaper
                            , mData = data.mDailyPaper;
                        //window.console.log(HrData)
                        HrData.list.forEach(function (item) {
                            var time = item.create_time.split(' ')[1];
                            time = time.split(':');
                            X.push(time[0] + ':' + time[1]);
                            Y.push(item.heartRate);
                        });
                        _this.HrInfo[0].num = HrData.count.max;
                        _this.HrInfo[1].num = HrData.count.avg;
                        _this.HrInfo[2].num = HrData.count.min;
                        this.heartRate(X, Y);

                        // bloodPressure 血压
                        var BpX = []
                            , BpY = []
                            , BpY1 = [];
                        BpData.list.forEach(function (item) {
                            var time = item.create_time.split(' ')[1];
                            time = time.split(':');
                            BpX.push(time);
                            BpY.push(item.sdp);
                            BpY1.push(item.dbp);
                        });
                        _this.BpInfo[0].num = BpData.count.sdp_max ;
                        _this.BpInfo[1].num = BpData.count.sdp_avg;
                        _this.BpInfo[2].num = BpData.count.sdp_min;
                        _this.BpInfoA[0].num = BpData.count.dbp_max;
                        _this.BpInfoA[1].num = BpData.count.dbp_avg;
                        _this.BpInfoA[2].num = BpData.count.dbp_min;
                        this.bloodPressure(BpX, BpY, BpY1);

                        var boX = []
                            , boY = [];
                        BoData.list.forEach(function (item) {
                            var time = item.create_time.split(' ')[1];
                            time = time.split(':');
                            boX.push(time[0] + ':' + time[1]);
                            boY.push(item.oxygen);
                        });
                        this.bloodOxygen(boX, boY);
                        _this.BoInfo[0].num = BoData.count.max;
                        _this.BoInfo[1].num = BoData.count.avg;
                        _this.BoInfo[2].num = BoData.count.min;

                        var mX = []
                            , mY = [];
                        mData.list.forEach(function (item) {
                            mX.push(item.date);
                            mY.push(item.step_count);
                        });
                        this.motion(mX, mY);
                        _this.mInfo[0].num = mData.step_count;
                        _this.mInfo[1].num = mData.kilometre;
                        _this.mInfo[2].num = mData.calorie;
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        methods: {
            heartRate(data, value) {
                // 心率 绘制图表
                let heartRate = echarts.init(document.getElementById('heartRate'));
                heartRate.setOption({
                    title: {show: false},
                    grid: {
                        top: 30,
                        bottom: 50,
                        left: '10%',
                        right: '2%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: data,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#a9a8ae',  // 更改坐标轴文字颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#E8EDE9'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#a9a8ae',  // 更改坐标轴文字颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#FFF'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E8EDE9',
                                type: 'solid'
                            }

                        }
                    },
                    dataZoom: [
                        {
                            type: 'slider',//图表下方的伸缩条
                            show: true, //是否显示
                            realtime: true, //拖动时，是否实时更新系列的视图
                            start: 0, //伸缩条开始位置（1-100），可以随时更改
                            end: 25, //伸缩条结束位置（1-100），可以随时更改
                        }
                    ],
                    series: [{
                        name: '测量值',
                        data: value,
                        type: 'line',
                        itemStyle: {
                            color: '#ff0000',
                            borderColor: '#ff0000'
                        },
                        connectNulls: true
                    }]
                });
            },
            bloodPressure(data, Y1, Y2) {
                // 基于准备好的dom，初始化echarts实例
                let bloodPressure = echarts.init(document.getElementById('bloodPressure'));
                // 绘制图表
                bloodPressure.setOption({
                    title: {
                        show: false
                    },
                    grid: {
                        top: 30,
                        bottom: 50,
                        left: '10%',
                        right: '2%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: data
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'slider',//图表下方的伸缩条
                            show: true, //是否显示
                            realtime: true, //拖动时，是否实时更新系列的视图
                            start: 0, //伸缩条开始位置（1-100），可以随时更改
                            end: 20, //伸缩条结束位置（1-100），可以随时更改
                        }
                    ],
                    series: [{
                        name: '收缩压',
                        type: 'line',
                        data: Y1,
                        connectNulls: true
                    },
                        {
                            name: '舒张压',
                            type: 'line',
                            data: Y2,
                            connectNulls: true
                        }]
                });
            },
            bloodOxygen(data, value){
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('bloodOxygen'));
                // 绘制图表
                myChart.setOption({
                    title: {
                        show: false
                    },
                    grid: {
                        top: 30,
                        bottom: 50,
                        left: '10%',
                        right: '2%'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: data,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#a9a8ae',  // 更改坐标轴文字颜色
                            }
                        },
                        axisLine:{
                            lineStyle: {
                                color:'#E8EDE9'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#a9a8ae',  // 更改坐标轴文字颜色
                            }
                        },
                        axisLine:{
                            lineStyle: {
                                color:'#FFF'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E8EDE9',
                                type: 'solid'
                            }

                        }
                    },
                    dataZoom: [
                        {
                            type: 'slider',//图表下方的伸缩条
                            show : true, //是否显示
                            realtime : false, //拖动时，是否实时更新系列的视图
                            start : 0, //伸缩条开始位置（1-100），可以随时更改
                            end : 12, //伸缩条结束位置（1-100），可以随时更改
                        }
                    ],
                    series: [{
                        name:'测量值',
                        data: value,
                        type: 'line',
                        itemStyle: {
                            color: '#ff0000',
                            borderColor: '#ff0000'
                        },
                        connectNulls:true
                    }]
                });
            },
            motion(data, value) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('motion'));
                // 绘制图表
                myChart.setOption({
                    color: ['#67D098'],
                    title: {
                        show: false
                    },
                    grid: {
                        left: '1%',
                        right: '5%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {name: '运动'},
                    toolbox: {
                        show: true,
                        feature: {
                            // mark : {show: true},//辅助线
                            dataView: {show: true, readOnly: false},//数据视图
                            magicType: {show: true, type: ['line', 'bar']},
                            restore: {show: true},//还原
                            saveAsImage: {show: true}//保存图片
                        }
                    },
                    calculable: false,
                    xAxis: [
                        {
                            type: 'category',
                            data: data
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [{
                        name:'运动',
                        type:'bar',
                        data: value,
                        barWidth: '15%',
                    }]
                });
            }
        }
    };

</script>
<style lang="scss" scoped>
    #content {
        width: 95%;
        margin: 0 auto 20px;
        .c-title {
            padding-left: 5px;
            span {
                font-size: 16px;
                font-weight: bold;
            }
            label {
                font-size: 16px;
                color: #009245;
                font-weight: bold;
            }
        }

        .main {
            height: 300px;
        }

        .count {
            height: 100px;
            margin: 0 auto;

            border-radius: 8px;
            &>div {
                background-color: #eefbf4;
                float: left;
                width: 32.9%;
                height: 100px;
                text-align: center;
            }
            &>div:nth-child(1) {
                border-radius: 8px 0 0 8px;
            }
            &>div:nth-child(2) {
                border-left: 2px solid #fff;
                border-right: 2px solid #fff;
            }
            &>div:nth-child(3) {
                border-radius: 0 8px 8px 0;
            }

            .val {
                padding-top: 20px;
                font-size: 26px;
                color: #666666;
            }
            .title {
                font-size: 15px;
                color: #cccccc;
            }
        }
        .c-bs {
            .s1 {
                .van-col {
                    font-size: 14px;
                    background: #5dc88f;
                    color: #fff;
                    text-align: center;
                    border-right: 1px solid #fff;
                    border-bottom: 1px solid #fff;
                    line-height: 25px;
                }
                .c-1 {
                    height: 51px;
                    line-height: 51px;
                }
                .c-2 {
                    height: 51px;
                }
            }
            .s2 {
                .van-col {
                    font-size: 12px;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                    border-right: 1px solid #eee;
                    border-bottom: 1px solid #eee;
                    &:nth-child(1) {
                        border-left: 1px solid #eee;
                    }
                    &.green {
                        background: #67d098;
                        color: #fff;
                    }
                    &.orange {
                        background: #f5a367;
                        color: #fff;
                    }
                    &.red {
                        background: #ec5982;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>
